import { Flex } from 'components/Flex';
import { useShiftModalDataContext } from 'modals/ShiftModal/ShiftModalProvider.data.context';
import { useSendToAgenciesFormContext } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgencies.form.context';
import { useFetchAvailableTeamMembersCountDataContext } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/OpenShift/FetchAvailableTeamMembersCount.data.context';
import { OpenPay } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/ShiftPay/OpenPay';
import {
  InfoSection,
  SendToAgenciesBoldText,
  SendToAgenciesText,
} from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesView.styled';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { formatPlural } from 'utils/formatPlural';
import { getTranslatedResponse } from 'utils/getTranslatedResponse';

function SummaryDetailsInfo() {
  const { t } = useTranslation();
  const { values } = useSendToAgenciesFormContext();
  const { data: availableTeamMembersCountData } = useFetchAvailableTeamMembersCountDataContext();
  return (
    <Fragment>
      {!!availableTeamMembersCountData?.requestAllJanes?.totalCount && (
        <SendToAgenciesText>
          {`${availableTeamMembersCountData?.requestAllJanes?.totalCount} ${t(
            'shift_modal:AVAILABLE_AGENCY_MEMBERS',
          )}`}
        </SendToAgenciesText>
      )}

      <SendToAgenciesBoldText>
        {`${t('shift_modal:SEND_OUT')} :`}&nbsp;
        {values.specific_time_selection[0] === 'now' ? (
          <SendToAgenciesText>{t('shift_modal:IMMEDIATELY')}</SendToAgenciesText>
        ) : (
          <SendToAgenciesText>
            {`${formatPlural(
              'hour',
              Number.parseInt(values.specific_time_selection[0], 10),
              true,
            )} ${t('shift_modal:BEFORE_SHIFT_STARTS')}`}
          </SendToAgenciesText>
        )}
      </SendToAgenciesBoldText>
    </Fragment>
  );
}

export function OpenShiftComponent() {
  const { t, i18n } = useTranslation();
  const { data } = useShiftModalDataContext();
  const order = data?.order;

  const marketplacePriceRange = order?.position?.marketplacePriceRange;
  const hasMarketplacePay = !!(marketplacePriceRange?.min || marketplacePriceRange?.max);

  return (
    <Flex flexDirection="column" gap="32px">
      <Flex flexDirection="column" gap="8px">
        <Flex alignItems="center">
          <SendToAgenciesBoldText>{`${getTranslatedResponse(order?.status.name, 'status', i18n, t)}
          ${t('shift_modal:SHIFT')}`}</SendToAgenciesBoldText>
        </Flex>

        <InfoSection flexDirection="column" alignContent="baseline" gap="14px">
          <SummaryDetailsInfo />
        </InfoSection>

        <Flex flexDirection="column" padding="0px 8px 0px 8px">
          <SendToAgenciesText>
            {t('shift_modal:THIS_SHIFT_WILL_BECOME_AVAILABLE_TO')}&nbsp;
            <SendToAgenciesBoldText>{formatPlural(order?.position?.name)}</SendToAgenciesBoldText>
            &nbsp;
            {order?.biddable
              ? t('shift_modal:IN_THE_MARKETPLACE_TO_ACCEPT_BIDDING')
              : t('shift_modal:IN_THE_MARKETPLACE_TO_ACCEPT')}
          </SendToAgenciesText>
        </Flex>
      </Flex>
      {hasMarketplacePay && <OpenPay />}
    </Flex>
  );
}
